import { render, staticRenderFns } from "./RolePermission.vue?vue&type=template&id=53a049dc&scoped=true"
import script from "./RolePermission.vue?vue&type=script&lang=js"
export * from "./RolePermission.vue?vue&type=script&lang=js"
import style0 from "./RolePermission.vue?vue&type=style&index=0&id=53a049dc&prod&scoped=true&lang=css"
import style1 from "./RolePermission.vue?vue&type=style&index=1&id=53a049dc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a049dc",
  null
  
)

export default component.exports